import { Space, Typography } from 'antd'
import { PlusCircleOutlined } from "@ant-design/icons"
import { red } from "@ant-design/colors"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-solid-svg-icons'

const Link = Typography.Link

type Props = {
  onAdd: () => void,
  onRemove: () => void
}

const AddRemove = ({ onAdd, onRemove }: Props) => <Space size="middle" style={{ fontSize: '1.25em' }}>
  <Link onClick={onAdd}><PlusCircleOutlined /></Link>
  <Link onClick={onRemove} style={{ color: red.primary }}><FontAwesomeIcon icon={faTrash} /></Link>
</Space>

export default AddRemove
